import React, { useState } from 'react';
import { Box, Typography, Button, TextField } from '@mui/material';
import NoteItem from './NoteItem';
import Heading from "../../../../../../../components/Heading";
import PrimaryButton from "../../../../../../../components/Button/Button";
import AddIcon from '@mui/icons-material/Add';
import { useHPDTicketNotes } from '../../../../../../../reactQuery/violations';
import { useParams } from 'react-router-dom';
import FormDialog from "../../../../../../../components/Dialog/FormDialog";
import CustomDatePicker from '../../../../../../../components/DatePicker';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useMutation } from '@tanstack/react-query';
import { createHPDTicketNote } from '../../../../../../../sevices/violationsApi';
import { isAdmin } from '../../../../../../../utils/helpers';

const schema = yup.object({
  content: yup.string().required('Note is required'),
  // date: yup.date().nullable(),
});

const NotesSection = () => {
  const [open, setOpen] = useState(false);
  const { id } = useParams();
  const { responseData, isLoading, isError, refetch } = useHPDTicketNotes(id);

  const { mutate: createNote } = useMutation({
    mutationFn: (data) => createHPDTicketNote(id, data),
    onSuccess: () => {
      refetch();
      setOpen(false);
      reset();
    },
    onError: (error) => {
      console.log(error);
    },
  });
  
  const { 
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      content: '',
      // date: null,
    },
  });

  console.log(responseData);

  const handleAddNote = (data) => {
    console.log(data);
    createNote(data);
    // reset();
  };

  const handleClose = () => {
    setOpen(false);
    reset();
  };

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <Box className="notes-section">
      <Heading title={"Notes"}>
        {isAdmin() && (
          <PrimaryButton
            variant="contained"
            className={`capitalize btn-bg-orange `}
            onClick={handleOpen}
            startIcon={<AddIcon />}
          >
            Add Note
          </PrimaryButton>
        )}
      </Heading>

      <FormDialog open={open} handleClose={handleClose} title="Add Note">
        <form onSubmit={handleSubmit(handleAddNote)}>
          <Box sx={{ mb: 3 }}>
            <CustomDatePicker
              label={"Date"}
              field={{ name: "note_date", label: "Date" }}
              setValue={setValue}
              excludeDates={[]}
              isShring={true}
              placeholder={"Select date"}
              disabledPast={false}
              errors={errors}
            />
          </Box>

          <Box sx={{ mb: 3 }}>
            <TextField
              fullWidth
              multiline
              rows={6}
              placeholder="Start typing..."
              label="Note"
              InputLabelProps={{ shrink: true }}
              {...register("content")}
              error={Boolean(errors?.content)}
              helperText={errors.content?.message}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              mt: 4,
              mb: 2,
            }}
          >
            <Button
              variant="outlined"
              onClick={handleClose}
              sx={{ borderRadius: "4px", textTransform: "none" }}
              className="secondary-button"
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              type="submit"
              sx={{
                borderRadius: "4px",
                bgcolor: "#F97316",
                "&:hover": { bgcolor: "#EA580C" },
                textTransform: "none",
              }}
            >
              Submit
            </Button>
          </Box>
        </form>
      </FormDialog>

      {responseData?.length === 0 && (
        <Box sx={{ textAlign: "center", py: 4 }}>
          <Typography variant="body1" color="text.secondary">
            No notes found
          </Typography>
        </Box>
      )}
      {responseData?.length > 0 && (
        <Box className="notes-list">
          {responseData.map((note) => (
            <NoteItem key={note.id} note={note} refetch={refetch} />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default NotesSection; 